<template>
<v-main class="pa-3 pb-4">
  <v-layout row wrap>
    <v-flex xs12 sm6 class="pa-3 pb-4">
      <v-card class="rounded-xl">
        <v-card-title>
          <v-toolbar-title>Administradores ativos
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="searchAtivos" append-icon="search" label="Buscar por nome" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="listaFuncionariosAtivos" no-data-text="Nenhum Administrador ativo" :search="searchAtivos">
          <template v-slot:items="props">
            <td>{{ props.item.nome }}</td>
            <td>{{ props.item.nomeUnidade }}</td>

            <!-- <td class="justify-center layout px-0">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" small="" fab @click="editarDadosAdministradorUnidade(props.item)">
                    <v-icon color="success">
                      edit
                    </v-icon>
                  </v-btn>
                </template>
                <span>alterar dados</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" @click="desativarAdministrador(props.item)" fab small="" color="#E57373">
                    <v-icon>
                      remove
                    </v-icon>
                  </v-btn>
                </template>
                <span>desativar administrador</span>
              </v-tooltip>
            </td> -->
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon small v-on="on" class="mr-2" @click="editarDadosAdministradorUnidade(item)">
                  mdi-pencil
                </v-icon>
              </template>
              <span>alterar dados</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" color="error" class="mr-2" @click="desativarAdministrador(item)">
                  remove
                </v-icon>
              </template>
              <span>desativar administrador</span>
            </v-tooltip>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              Sua busca por "{{ searchAtivos }}" não encontrou resultados.
            </v-alert>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>

    <v-flex xs12 sm6 class="pa-3 pb-4">

      <v-card class="rounded-xl">
        <v-card-title>
          <v-toolbar-title>Administradores desativos
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="searchDesativos" append-icon="search" label="Buscar por nome" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headersDesativo" no-data-text="Nenhum Administrador desativo" :items="listaFuncionariosDesativos" :search="searchDesativos">
          <template v-slot:items="props">
            <td>{{ props.item.nome }}</td>
            <td>{{ props.item.nomeUnidade }}</td>

            <td class="justify-center layout px-0">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" fab small="" color="#4DB6AC" @click="ativarAdministrador(props.item)">
                    <v-icon>
                      add
                    </v-icon>
                  </v-btn>
                </template>
                <span></span>
              </v-tooltip>

            </td>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" color="success" class="mr-2" @click="ativarAdministrador(item)">
                  add
                </v-icon>
              </template>
              <span>ativar administrador</span>
            </v-tooltip>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              Sua busca por "{{ searchDesativos }}" não encontrou resultados.
            </v-alert>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
  </v-layout>

  <v-layout style="height: 90px; position: relative" right bottom>
    <v-btn id="mybutton" top-of="footer" right fab dark color="teal darken-4" @click="" :to="{path:'/cadastrarAdministrador'}">
      <v-icon dark>add</v-icon>
    </v-btn>
  </v-layout>
</v-main>
</template>

<script>
import administradorService from '../../../services/administrador.service'

export default {
  name: 'listaAdministrador',
  data() {
    return {
      page: 1,
      searchAtivos: '',
      searchDesativos: '',
      tipo: 5,
      isEditing: true,
      listaFuncionarios: [],
      listaFuncionariosAtivos: [],
      listaFuncionariosDesativos: [],
      administradorSelecionado: null,
      headers: [{
          text: 'Nome do Administrador ',
          align: 'left',
          sortable: true,
          value: 'nome'
        },
        {
          text: 'Nome da Unidade ',
          align: 'center',
          sortable: true,
          value: 'nome'
        },
        // { text: 'unidade Administrada', value: 'id' },
        {
          text: 'Ações',
          value: 'actions',
          sortable: false
        }
        // { text: 'Carbs (g)', value: 'carbs' },
        // { text: 'Protein (g)', value: 'protein' },
        // { text: 'Iron (%)', value: 'iron' }
      ],
      headersDesativo: [{
          text: 'Nome do Administrador ',
          align: 'center',
          sortable: true,
          value: 'nome'
        },
        {
          text: 'Nome da Unidade ',
          align: 'center',
          sortable: true,
          value: 'nome'
        },
        // { text: 'unidade Administrada', value: 'id' },
        {
          text: 'Ações',
          value: 'actions',
          sortable: false
        }
        // { text: 'Carbs (g)', value: 'carbs' },
        // { text: 'Protein (g)', value: 'protein' },
        // { text: 'Iron (%)', value: 'iron' }
      ],
      listaAdministradores: [],
      user: null,
      items: [{
          username: 'Elvis',
          idUnidade: 1,
          nome: 'elvinasd'
        },
        {
          username: 'Cassio',
          idUnidade: 3,
          nome: 'elvinawersd'
        },
        {
          username: 'Leandro',
          idUnidade: 2,
          nome: 'wer'
        },
        {
          username: 'Ana',
          idUnidade: 15,
          nome: 'wer'
        },
        {
          username: 'Ricardo',
          idUnidade: 3,
          nome: 'wer'
        },
        {
          username: 'Cleison',
          idUnidade: 22,
          nome: 'wer'
        }
      ]
    }
  },
  components: {
    // HelloWorld
  },
  mounted() {
    console.log('em mounted adm...')
    this.user = this.$store.getters.usuario
    // console.log(this.user);
    this.retornarAdministradores()
  },
  methods: {
    retornarAdministradores() {
      console.log('em retornar Administradores...')
      administradorService.administrador
        .retornarAdministradores()
        .then(rsp => {
          console.log('rsp oi:')
          this.listaFuncionarios = rsp.data
          console.log(this.listaFuncionarios)
          this.listaFuncionarios.forEach(funcionario => {
            if (funcionario.ativo) {
              this.listaFuncionariosAtivos.push(funcionario)
            } else {
              this.listaFuncionariosDesativos.push(funcionario)
            }
          })
          // console.log(this.listaChamadas);
          // this.servicoTeste = rsp.data
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    editarDadosAdministradorUnidade(item) {
      console.log('em editar dados administrador...')
      this.$router.push({
        name: 'editarDadosAdministradorUnidade',
        params: {
          item: item
        }
      })
    },

    desativarAdministrador(item) {
      console.log('em desativar admins...')

      const index = this.listaFuncionariosAtivos.indexOf(item)
      if (confirm('Deseja desativar esse Administrador?')) {
        // this.items.splice(index, 1)
        administradorService.administrador
          .desativarFuncionario(item.username, this.tipo)
          .then(rsp => {
            console.log('rsp oi:')
            if (rsp.data == true) {
              this.listaFuncionariosAtivos.splice(index, 1)
              this.listaFuncionariosDesativos.push(item)
            }
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      } else {}
    },

    ativarAdministrador(item) {
      console.log('em atiar administrador...')
      const index = this.listaFuncionariosDesativos.indexOf(item)
      if (confirm('Deseja ativar esse Adminsitrador?')) {
        // this.items.splice(index, 1)
        administradorService.administrador
          .ativarFuncionario(item.username, this.tipo)
          .then(rsp => {
            console.log('rsp oi:')
            if (rsp.data == true) {
              this.listaFuncionariosDesativos.splice(index, 1)
              this.listaFuncionariosAtivos.push(item)
            }
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    }
  },
  created() {
    console.log('created...')
  }
}
</script>

<style scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31B0D5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: 20px;
  right: 10px;
}
</style>
